import http from '@/utils/request'

export const reportByDate = (params)=>{
  return http.request({
    url:"/report/listByMonth",
    method:"GET",
    params:params
  })

}
export const delReport =(params)=>{
  return http.request({
    url:"/report/" +params,
    method:"delete"
  })
}

export const review = (params) =>{
  return http.request({
    url:"/report/review",
    method:"PUT",
    params:params
  })
}
export const reportPage = (params)=>{
  return http.request({
    url:"/report/page",
    method:"GET",
    params:params
  })

}
export const addReport =(data) =>{
  return http.request({
    url:"/report",
    method:"POST",
    data:data
  })
}

export const uploadFile = (filePath) => {
  return http.uploadFile({
    url: '/common/upload',
    filePath: filePath,
    name: 'file'
  })
}
